export default {
  path: '/email-outbox/:id?',
  name: 'email-outbox',
  component: () => import(/* webpackChunkName: "email-outbox" */ './ListViewEmailOutbox.vue'),
  props: true,
  meta: {
    requiresAuth: true,
    pageTitle: 'Email outbox'
  }
}
